// 美国含税订单默认收起税费的游戏
export const TAX_FOLD_GAME_IDS = [175];

export const matchesTaxFoldGame = gameId => {
  return TAX_FOLD_GAME_IDS.includes(+gameId);
};
